var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetBigIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 107,
    viewBox: "0 0 104 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9056 103.459V89.1287C73.0928 86.7479 72.7712 84.3541 71.9618 82.1071C71.1524 79.8601 69.8741 77.8108 68.2118 76.0961C83.8908 74.3485 100.369 68.4064 100.369 41.1429C100.367 34.1714 97.6858 27.4673 92.8788 22.418C95.1547 16.3188 94.994 9.57699 92.4294 3.59326C92.4294 3.59326 86.5373 1.8456 72.9056 10.9834C61.4609 7.88161 49.3971 7.88161 37.9524 10.9834C24.3206 1.8456 18.4285 3.59326 18.4285 3.59326C15.8638 9.57699 15.7029 16.3188 17.9791 22.418C13.1362 27.5047 10.4518 34.2695 10.4892 41.2927C10.4892 68.3565 26.967 74.2985 42.646 76.2459C41.0032 77.9437 39.7363 79.968 38.9275 82.1875C38.1189 84.407 37.7866 86.7723 37.9524 89.1287V103.459",
    stroke: "#603085",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9532 93.4719C22.9732 98.3314 10.49 93.4719 3 78.4919",
    stroke: "#603085",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetBigIcon);
export default __webpack_public_path__ + "static/media/pet_big_icon.4ba7b51c1648c0fd0ff10536c9b72a94.svg";
export { ForwardRef as ReactComponent };